module.exports = __webpack_public_path__ + "img/w41.8ec7be46.svg";